import { User as Auth0User } from '@auth0/auth0-react'
import {User} from "@yaak/components/services/api/api";

export const isSimAdmin = (user?: Auth0User) => {
    return user?.[`${process.env.AUTH0_NAMESPACE}/roles`].indexOf('sim-admin') !== -1
}

export const isAuth0DsAdmin = (user?: Auth0User) =>
    user?.[`${process.env.AUTH0_NAMESPACE}/roles`].indexOf('ds-admin') !== -1

export const isAuth0SynpliAdmin = (user?: Auth0User) =>
    user?.[`${process.env.AUTH0_NAMESPACE}/roles`].indexOf('synpli-admin') !== -1

export const isDsAdmin = (user?: User) => {
    return user?.roles?.indexOf('ds-admin') !== -1;
}

export const isDsInstructor = (user?: User) => {
    return user?.roles?.indexOf('ds-instructor') !== -1;
}

export const isSynpliAdmin = (user?: User) => {
    return user?.roles?.indexOf('synpli-admin') !== -1;
}